module.exports = __webpack_public_path__ + "img/14.894a68f7.svg";